import { LearningItem } from "./types";

export const shapes: LearningItem[] = [
  {
    id: "circle",
    label: "Circle",
    word: "Circle",
    model: "/models/circle.glb",
    audio: "/audio/circle.mp3",
    color: "#ef4444", // red
    category: "shape",
  },
  {
    id: "square",
    label: "Square",
    word: "Square",
    model: "/models/square.glb",
    audio: "/audio/square.mp3",
    color: "#3b82f6", // blue
    category: "shape",
  },
  {
    id: "triangle",
    label: "Triangle",
    word: "Triangle",
    model: "/models/triangle.glb",
    audio: "/audio/triangle.mp3",
    color: "#10b981", // green
    category: "shape",
  },
  {
    id: "rectangle",
    label: "Rectangle",
    word: "Rectangle",
    model: "/models/rectangle.glb",
    audio: "/audio/rectangle.mp3",
    color: "#f59e0b", // amber
    category: "shape",
  },
  {
    id: "star",
    label: "Star",
    word: "Star",
    model: "/models/star.glb",
    audio: "/audio/star.mp3",
    color: "#8b5cf6", // purple
    category: "shape",
  },
  {
    id: "heart",
    label: "Heart",
    word: "Heart",
    model: "/models/heart.glb",
    audio: "/audio/heart.mp3",
    color: "#ec4899", // pink
    category: "shape",
  },
];

